import { useEffect } from 'react';

import { useVerUrlProtegidaMutation } from '../../../store/api/endpoints/workhopsUploadVideoApiSlice';


export default function WorkshopsPrevisualizar({ url }) {

    const [
        getUrl,
        {
            data: responseGetUrl,
            isUninitialized: isUninitializedGetUrl,
            isLoading: isLoadingGetUrl,
            isSuccess: isSuccessGetUrl,
            isError: isErrorGetUrl,
            error: errorDataGetUrl,
        }
    ] = useVerUrlProtegidaMutation();

    useEffect(() => {
        getUrl({ body: { url } })
    }, [])

    if (isUninitializedGetUrl || isLoadingGetUrl) return (<>...</>)

    if (isSuccessGetUrl) {
        console.log(responseGetUrl.signedUrl)
        return (
            <video
                src={responseGetUrl.signedUrl}
                controls
                style={{ maxWidth: '100%', height: 'auto', display: 'block', backgroundColor: '#000' }}
            >
                Tu navegador no soporta el elemento de video.
            </video>
        );
    }
}
